import * as React from 'react';
import {Helmet} from 'react-helmet';
import {generatePath} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import type {FilterObject} from 'nutshell-core/types';

import {headTitle} from 'shells/document/head-title';

import type {ReportURLParams} from '../../reports/report-types';

import {CompetitorsPage} from './competitors-page';
import {getTab} from './helpers';

export type CompetitorsPageTab = 'charts' | 'settings' | 'paid' | 'organic';

type Props = ContextRouter & {
    activeFilters: FilterObject[];
    onParamChange: (arg1: any, arg2: boolean) => any;
    onParamPush: (arg1: any, arg2: boolean) => any;
    urlParams: ReportURLParams<'contacts'>;
    onRemoveAllFilters: () => void;
};

export function CompetitorsPageWrapper(props: Props) {
    const getPathForTab = (newTab: CompetitorsPageTab): string => {
        return generatePath(props.match.path, {
            tab: newTab,
        });
    };

    const getActiveTab = (): CompetitorsPageTab => {
        return getTab(props.match.params.tab);
    };

    const onChangeTab = (newTab: CompetitorsPageTab) => {
        props.history.push({
            pathname: getPathForTab(newTab),
            search: props.history.location.search,
        });
    };

    return (
        <>
            <Helmet>
                <title>{headTitle('CompetitorSpy')}</title>
            </Helmet>
            <CompetitorsPage
                getPathForTab={getPathForTab}
                activeTab={getActiveTab()}
                onChangeTab={onChangeTab}
                {...props}
            />
        </>
    );
}
